import { apiClient } from './client'
import type { ProductBadge } from './endpoints'

const PREFIX = '/api/internal/customer'

export type CartItemResponse = {
  /** ID строки корзины (CartItem.pk) */
  id: number
  product_id: number
  product_slug?: string
  variant_id?: number | null
  variant_sku?: string | null
  quantity: number
  product_name: string
  /** Цена с бэка (строка или число, без округления) */
  price: number | string
  base_price?: number | string
  final_price?: number | string
  discount_percent?: number | string | null
  image?: string | null
  available_quantity?: number
  badges?: ProductBadge[]
  promo_badge_text?: string | null
}

export const cartApi = {
  getCart: () =>
    apiClient.get<CartItemResponse[]>(`${PREFIX}/cart/`).then((r) => r.data),

  addItem: (product_id: number, quantity: number, variant_id?: number | null) =>
    apiClient
      .post<CartItemResponse>(`${PREFIX}/cart/`, {
        product_id,
        quantity,
        ...(variant_id != null ? { variant_id } : {}),
      })
      .then((r) => r.data),

  /** Удалить строку корзины по её id (CartItem.pk) */
  removeItem: (cartLineId: number) =>
    apiClient.delete(`${PREFIX}/cart/${cartLineId}/`),

  syncCartFavorites: (payload: {
    cart: Array<
      | { product_id: number; quantity: number; variant_id?: number }
      | { id: number; quantity: number; variant_id?: number }
    >
    favorite_ids: number[]
  }) =>
    apiClient
      .post<{ cart: CartItemResponse[]; favorite_ids: number[] }>(
        `${PREFIX}/sync_cart_favorites/`,
        payload
      )
      .then((r) => r.data),
}
